import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PlanTicket.scss";
import { Pagination } from "@mui/material";
import usePaginations from "../../../Paginations";
import CardServiceNew from "../../../components/cardservicenew/CardServiceNew";
import Contant from "../../../Contant";
const PlaneTicketNew = (props) => {
  const [datas, setDatas] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
      url: Contant + "api/posts?type=news",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });
      if (response.data.news.airline_ticket === undefined) {
        setDatas(datas);
      } else {
        setDatas(response.data.news.airline_ticket);
      }

    

      // setDatas(() => {
      //   let allNews = [];
      //   for (let j in datakey) {
      //     allNews = allNews.concat(datakey[j]);
      //   }
      //   return allNews;
      // });
    };
    fetchData();
  }, [props]);

  // /----------------------------------------/

  // mathcs params id

  const getData = datas.find((item) => item.id);

  // console.log(getData);

  // get titile-id content

  const getContent = [];

  const content = "content";

  for (let list in getData) {
    if (list === content) {
      getContent.push(`${getData[list]}`);
    }
  }

  // console.log(getContent);

  function load_home(e) {
    (e || window.event).preventDefault();

    fetch( Contant+"api/data/contents/" + getContent)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("content").innerHTML = html;
      })
      .catch((error) => {
        console.warn(error);
      });
  }
  load_home();



  
  
  let [page, setPage] = useState(1);
  const PER_PAGE = 6  ;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  // console.log(_DATA)

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div>
      

     

      <div className="style_frame_main_cards">
        <div className="frame_service_items">
          {_DATA.currentDatas().map((item, index) => (
            <div key={index}>
              <CardServiceNew
                Title={item.title}
                image={
                  "https://tiendungfinance.com.vn/api/data/images/" +
                  item.coverPhoto
                }
                date={item.date}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="frame_piantion_news">
      <Pagination
        count={count}
        size="small"
        page={page}
        variant="outlined"
        shape="rounded"
        onChange={handleChange}
      />
      </div>
    </div>
  );
};

export default PlaneTicketNew;
